import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import queryString from "query-string";

import { init } from "containers/Home/reducer";
import { getAuthenticated, handleLogout, getTableauDataOptions } from "containers/Login/reducer";
import UploadContainer from "containers/Upload/Upload";
import {
  updateIsLeftPanelOpen,
  updateIsTableauMode,
  updateIsBusinessMode,
  updateIsDataMode,
  updateIsConsumerMode,
  getIsLeftPanelOpen,
  getIsTableauMode,
  getIsGoogleMode,
  getIsBusinessMode,
  getIsDataMode,
  getIsConsumerMode,
  getCurrentProjectId,
  startPolling,
  getUiState
} from "containers/App/reducer";
import { updateDatasetId } from "containers/Setup/reducer";
import { getViewingMobile } from "containers/MonitoringMobile/reducer";
import { goToHelpUri } from "containers/Help/reducer";
import {
  updateIsOpen,
  updateCollaborateTourIsOpen,
  updateIsOpenSense,
  updateIsOpenExplore,
  updateIsOpenNewChat
} from "containers/Tour/reducer";
import { getAibleViewType } from "containers/Project/reducer";
import { updateType } from "containers/View/reducer";
import { getSelectedAccount } from "containers/Accounts/reducer";
import { getIsEDG } from "containers/Gallery/GalleryReducer";
import { getIsMarketplaceDemo } from "containers/MarketplaceDemo/reducer";
import { getIsMarketplace } from "containers/Marketplace/reducer";
import { getIsDellDomain } from "containers/Login/reducer";
import * as nextReducer from "containers/Next/NextReducer";
import * as viewReducer from "containers/View/reducer";
import * as accountsReducer from "containers/Accounts/reducer";
import * as chatGPTReducer from "containers/ChatGPT/reducer";

import Header from "components/Header/Header";

class HeaderContainer extends React.Component {
  componentDidMount() {
    const { isAuthenticated } = this.props;

    if (isAuthenticated === true) {
      this.initData();
    }
  }

  componentDidUpdate(prevProps) {
    const { isAuthenticated } = this.props;

    if (prevProps.isAuthenticated === false && isAuthenticated === true) {
      this.initData();
    }
  }

  initData() {
    const { init, startPolling, isAuthenticated, uiState } = this.props;

    if (uiState?.type === "SHARE_LINK") {
      // Don't init stuff
      return;
    }

    if (isAuthenticated === true) {
      startPolling();
    }

    init();
  }

  handleToggleBusinessMode(val) {
    const { updateIsBusinessMode } = this.props;
    updateIsBusinessMode(val);
  }

  render() {
    const { isAuthenticated } = this.props;

    return isAuthenticated ? (
      <Header
        {...this.props}
        updateIsBusinessMode={(val) => this.handleToggleBusinessMode(val)}
        uploadContainer={<UploadContainer />}
      />
    ) : (
      <div />
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  init: () => dispatch(init()),
  startPolling: () => dispatch(startPolling()),
  handleLogout: () => dispatch(handleLogout()),
  updateIsLeftPanelOpen: (isOpen) => dispatch(updateIsLeftPanelOpen(isOpen)),
  goToHelpUri: () => dispatch(goToHelpUri()),

  updateIsTableauMode: (isTableauMode) => dispatch(updateIsTableauMode(isTableauMode)),
  updateIsBusinessMode: (isBusinessMode) => dispatch(updateIsBusinessMode(isBusinessMode)),
  updateIsDataMode: (isDataMode) => dispatch(updateIsDataMode(isDataMode)),
  updateIsConsumerMode: (isConsumerMode) => dispatch(updateIsConsumerMode(isConsumerMode)),
  updateIsTourOpen: (isOpen) => dispatch(updateIsOpen(isOpen)),
  updateIsTourOpenSense: (isOpenSense) => dispatch(updateIsOpenSense(isOpenSense)),
  updateIsTourOpenExplore: (isOpenExplore) => dispatch(updateIsOpenExplore(isOpenExplore)),
  updateCollaborateIsTourOpen: (isOpen) => dispatch(updateCollaborateTourIsOpen(isOpen)),
  updateIsOpenNewChat: (isOpenNC) => dispatch(updateIsOpenNewChat(isOpenNC)),

  updateDatasetId: (setupId, datasetId) => dispatch(updateDatasetId(setupId, datasetId)),

  updateType: (type) => dispatch(updateType(type)),

  updateHeaderMode: (headerMode) => dispatch(viewReducer.updateHeaderMode(headerMode)),
  updateAgentAutonomyView: (view) => dispatch(viewReducer.updateAgentAutonomyView(view))
});

const mapStateToProps = (state, ownProps) => {
  const projectId = getCurrentProjectId(state);

  const activeNextId = nextReducer.getCurrentNextId(state);

  return {
    uiState: getUiState(state),
    isMarketplace: getIsMarketplace(),
    isMarketplaceDemo: getIsMarketplaceDemo(),
    isAuthenticated: getAuthenticated(state),
    selectedAccount: getSelectedAccount(state),
    isLeftPanelOpen: getIsLeftPanelOpen(state),
    tableauData: getTableauDataOptions(state),
    isTableauMode: getIsTableauMode(state),
    isGoogleMode: getIsGoogleMode(state),
    isBusinessMode: getIsBusinessMode(state),
    isDataMode: getIsDataMode(state),
    isEDGMode: getIsEDG(),
    isDellDomain: getIsDellDomain(),
    isConsumerMode: getIsConsumerMode(state),
    aibleViewType: getAibleViewType(state, projectId),
    viewingMobile: getViewingMobile(state),
    isNextEnabled: true,

    headerMode: viewReducer.getHeaderMode(state),

    accounts: accountsReducer.getAccounts(state),
    accountsIsLoading: accountsReducer.getIsLoading(state),

    activeTab: nextReducer.getActiveTab(state, activeNextId),
    viewType: viewReducer.getType(state),

    chatApp: chatGPTReducer.getChatApp(state),
    headerDarkMode: chatGPTReducer.getHeaderDarkMode(state),
    agentAutonomyView: viewReducer.getAgentAutonomyView(state)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withRouter, withConnect)(HeaderContainer);
